import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { RouteTab } from "molecules/route-tabs/route-tabs";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";

interface PillNavProps {
    routes: RouteTab[];
    onPillClick?: (route: string) => Promise<void>;
}

const CSS_BASE_CLASS = "c-pill-nav";

const PillNav = (props: PillNavProps) => {
    const { routes, onPillClick } = props;
    const { pathname } = useLocation();
    const { push } = useHistory();

    const handlePillClick = async (pill: RouteTab) => {
        if (onPillClick) await onPillClick(pill.label);
        push(pill.route);
    };

    return (
        <nav className={CSS_BASE_CLASS} data-test-id="pill-nav--nav">
            <ul className={`${CSS_BASE_CLASS}__list`}>
                {routes.map((pill) => {
                    const isActive = pathname.startsWith(
                        pill.route.split("?")[0]
                    );
                    return (
                        <li
                            key={pill.label}
                            className={`${CSS_BASE_CLASS}__listItem ${isActive && "-active"}`}>
                            <Button
                                dataTestId={`pill-nav--${pill.label.toLowerCase()}-button`}
                                style={ButtonStyles.None}
                                onClick={() => handlePillClick(pill)}
                                cssClassName={`${CSS_BASE_CLASS}__link`}>
                                {pill.label}
                            </Button>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};

export default PillNav;
